import { LOGIN_USER, LOGOUT_USER, LOGIN_USER_ERROR, SET_LANG} from '../constants/ActionTypes'
import { normalizeLang } from '../utils/LangUtils';

const resetState = {
  invalid: false,
  lang: false,
  high_contrast: false,
  session: {
    token: false
  }
}

function getLang() {
  const storedLang = localStorage.getItem('lang');
  let lang = storedLang || navigator.language || 'pl-PL';
  lang = normalizeLang(lang);
  console.log('[getLang] storedLang:', storedLang, 'navigator.language:', navigator.language, 'normalized:', lang);
  return lang;
}


function setHighContrast(high_contrast){
  localStorage.setItem('high_contrast', high_contrast)
}

function getInitialState(){
  return {
    ...resetState,
    lang: getLang()
  }
}

export default function auth(state = getInitialState(), action) {
  switch (action.type) {
    case LOGIN_USER:
      console.log('[auth reducer] LOGIN_USER, lang before:', state.lang, 'lang after:', getLang());
      console.log('state lang', state.lang)
      return { ...state,
        lang: action.payload.lang || state.lang || getLang(),
        session: {
          'token': action.payload.token
        },
        invalid: false,
      }
    case LOGOUT_USER:
      console.log('[auth reducer] LOGOUT_USER, resetting state');
      return resetState
    case LOGIN_USER_ERROR:
      console.log('[auth reducer] LOGIN_USER_ERROR');
      return { ...state,
        invalid: true
      }
    case SET_LANG:
      console.log('[auth reducer] SET_LANG, lang from action.payload:', action.payload);
      return { ...state,
        lang: action.payload
      }
    default:
      return state
  }
}

